/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  email: 'email',
  website: 'website',
  phone: 'phone',
  mobilePhone: 'mobilePhone',
  edit: 'edit',
  cancel: 'cancel',
  save: 'save',
  requiredField: 'requiredField'
}; export default Keys;